module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAQCAYAAAAFzx/vAAABYklEQVRIS73US0oDQRAG4L/0BHGXC7jwDl4juBBEQWtAiA/Q4Lsh4iIi+ICYmkY3guDGQ3gF8QrJKuBeTUkNTQghM5lokoKBpru6Pmamusl7v6iqoqrzAKCqSkQdAJ2UsdpaeJKx5Vtu71zf+AvAO4B9EpEPAAuGTSHeDGwDmJsCZsSngecAjqYBElGdnHMzxWLxEcDKhNFXAEtkSEA9gLUJoS+tVmvZOfedgKE7yXtv3bo+ZvSpUCislkqlH6vbBQNCcRzXVTUaB0pED81mc8M5Z8coiX4wmROROwCb/0Tvmdlq2PnsxiAwWRSRGwDlP6LXzLwzaG8qaMlxHF+p6u6IaI2ZK2l7MsHwpjUAeznRKjOfZuUOBW1zo9G4IKKDrEKqehJFkV0imZELDJ+3qqrH/dWIyO7tCjNfDsPSujR1n4ic2T3Rk2AduM3Mt3mwkcHwT8tEdKiqswC2mPk5L2Z5v7NRlXNkSA9SAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./static/images/slices.png
// module id = XAK+
// module chunks = 1